import { GET_CONTACT_US_ENDPOINT } from '@/app/_libs/utils/constants/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// update user info request to update name , family , nationalcode  ****************
async function updateContactUsUsers(values) {
  const res = await fetch(`${GET_CONTACT_US_ENDPOINT}`, {
    method: 'POST',
    body: JSON.stringify({
      name: values.name,
      surname: values.surname,
      mobile: values.mobile,
      advisor_name: values.advisor_name,
      advisor_phone: values.advisor_phone,
      advisor_category: values.advisor_category,
    }),
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  });
  const userInfo = await res.json();
  console.log(userInfo);
  return userInfo;
}
const useContactUsUser = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values) => updateContactUsUsers(values),
    onSuccess: () => {
      queryClient.refetchQueries(['userContactUs', token]);
    },
  });
};
export { useContactUsUser };
